export const SERVICES_DATA = [
  {
    slug: "elektrik-ariza-tamir",
    title: "Elektrik Arıza & Tamir",
    shortTitle: "Elektrik Arıza ve Tamir",
    tag: "ACİL SERVİS",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHJlcGFpcmluZyUyMHdpcmVzJTIwd29ya3xlbnwwfHx8fDE3OTM3Nzk1NTd8MA&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Kısa devre, atan sigorta, kablo erimesi ve voltaj problemleri tespiti ve usta elinden garantili onarım.",
    meta: "Beylikdüzü'nde elektrik arıza tespiti ve tamiri. Kısa devre, atan sigorta, voltaj sorunlarına aynı gün müdahale. Arayın: 0530 956 27 70",
    pageDesc:
      "Beylikdüzü'nde elektrik arızasıyla karşılaştığınızda paniğe gerek yok. Kısa devre, sürekli atan sigorta, kablo erimesi, voltaj dalgalanması veya dairenin bir bölümünde elektrik kesintisi gibi sorunları yerinde tespit edip aynı gün onarıyoruz. Arızayı telefonda dinliyor, gerekli ekipmanla geliyoruz.",
    extra:
      "Arıza tespitinde tahmine değil ölçüme dayalı çalışıyoruz: multimetre ve faz kalemi ile hattı kontrol eder, sorunun kaynağını bulmadan parça değiştirmeyiz. Böylece aynı arızanın tekrar etmesini önler, gereksiz masraftan sizi koruruz. Onarım sonrası tüm hattı tekrar test edip teslim ederiz.",
    scope: [
      "Kısa devre tespiti ve onarımı",
      "Sürekli atan sigorta / kaçak akım arızası",
      "Kablo, buat ve ek noktası kontrolü",
      "Voltaj düşüklüğü ve dalgalanma tespiti",
      "Ark yapan priz ve anahtar onarımı",
      "Daire içi kısmi elektrik kesintisi",
    ],
  },
  {
    slug: "sigorta-pano",
    title: "Sigorta & Pano İşleri",
    shortTitle: "Sigorta ve Pano İşleri",
    tag: "GÜVENLİK",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1786177590769-f3b9fc8eb5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbGVjdHJpY2lhbiUyMHBhbmVsJTIwZnVzZXMlMjBicmVha2VyJTIwYm94fGVufDB8fHx8MTc5Mzc3OTU1MHww&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Sigorta kutusu değişimi, kaçak akım rölesi montajı, ana şalter ve klemens yenileme.",
    meta: "Beylikdüzü'nde sigorta kutusu değişimi, kaçak akım rölesi ve pano işleri. Güvenli, garantili montaj. Arayın: 0530 956 27 70",
    pageDesc:
      "Eskiyen sigorta kutuları ve düzensiz panolar hem güvenlik riski hem de sık arıza sebebidir. Beylikdüzü'nde konut ve iş yerlerinde sigorta kutusu değişimi, kaçak akım rölesi montajı, ana şalter ve klemens yenileme işlerini standartlara uygun şekilde yapıyoruz.",
    extra:
      "Pano yenilerken sadece parça değiştirmiyoruz: yük hesabı yapar, sigorta seçiciliğini ayarlar, her hattı etiketleriz. Böylece bir arızada hangi sigortanın kime ait olduğunu herkes anlar. Kaçak akım rölesi olmayan evlerde can güvenliği için montajını mutlaka öneriyoruz.",
    scope: [
      "Sigorta kutusu (dağıtım panosu) değişimi",
      "Kaçak akım rölesi montajı ve testi",
      "Ana şalter ve klemens yenileme",
      "Sigorta seçiciliği ve yük dengeleme",
      "Hat etiketleme ve pano düzenleme",
      "İş yeri kompanzasyon panosu bakımı",
    ],
  },
  {
    slug: "aydinlatma-led",
    title: "Aydınlatma & LED Montajı",
    shortTitle: "Aydınlatma ve LED Montajı",
    tag: "DEKORATİF",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1504972090022-6edb81e4e534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjZWlsaW5nJTIwbGlnaHQlMjBidWxiJTIwaW50ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc5Mzc3OTU1N3ww&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Avize montajı, gizli LED şerit çekimi, spot lambaları, bahçe ve alan aydınlatma tesisatı.",
    meta: "Beylikdüzü'nde avize montajı, gizli LED şerit, spot ve bahçe aydınlatması. Temiz montaj, net fiyat. Arayın: 0530 956 27 70",
    pageDesc:
      "Doğru aydınlatma evin havasını değiştirir. Beylikdüzü'nde avize montajından gizli LED şerit çekimine, spot lambalardan bahçe aydınlatmasına kadar tüm aydınlatma işlerini yapıyoruz. Alçıpan içi gizli ışık, merdiven LED'i ve vitrin aydınlatması gibi dekoratif işlerde deneyimliyiz.",
    extra:
      "Montaj öncesi tavan yapısını ve elektrik hattını kontrol eder, ağır avizelerde uygun dübel ve askı kullanırız. LED şerit işlerinde trafo yerleşimini gizler, ısınma payı bırakırız. Dış mekân işlerinde suya ve neme dayanıklı armatür tercih ederiz.",
    scope: [
      "Avize ve sarkıt montajı",
      "Gizli LED şerit ve trafo kurulumu",
      "Spot ve ray spot montajı",
      "Bahçe, balkon ve dış mekân aydınlatma",
      "Sensörlü ve dimmerli aydınlatma",
      "İş yeri vitrin ve tabela aydınlatması",
    ],
  },
  {
    slug: "priz-anahtar",
    title: "Priz & Anahtar Montajı",
    shortTitle: "Priz ve Anahtar Montajı",
    tag: "MONTAJ",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1590059694337-ec9f631ec9a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdpcmluZyUyMHRvb2xzJTIwZGFyayUyMGRyYW1hdGljJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkzNzc5NTUwfDA&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Eski priz/anahtar değişimi, ilave priz hattı çekimi, TV ve internet altyapı sonlandırma.",
    meta: "Beylikdüzü'nde priz ve anahtar değişimi, ilave priz hattı çekimi, USB'li priz montajı. Aynı gün servis: 0530 956 27 70",
    pageDesc:
      "Eskiyen, gevşeyen veya ark yapan prizler risklidir; yetersiz priz sayısı da günlük hayatı zorlaştırır. Beylikdüzü'nde eski priz ve anahtar değişimi, ilave priz hattı çekimi, USB'li priz ve çocuk korumalı priz montajını temiz işçilikle yapıyoruz.",
    extra:
      "İlave priz hatlarını mümkün olduğunca mevcut tesisattan ve kablo kanalıyla çekerek kırma işlemini en aza indiriyoruz. Mutfak ve banyo gibi ıslak hacimlerde korumalı priz, TV ünitesi arkasında gizli priz ve zayıf akım sonlandırma gibi detayları da plana dahil ediyoruz.",
    scope: [
      "Eski priz ve anahtar değişimi",
      "İlave priz hattı çekimi",
      "USB'li ve çocuk korumalı priz montajı",
      "TV ve internet prizi sonlandırma",
      "Islak hacim (banyo/mutfak) korumalı priz",
      "Dış mekân kapaklı priz montajı",
    ],
  },
  {
    slug: "kamera-guvenlik",
    title: "Kamera & Güvenlik Sistemleri",
    shortTitle: "Kamera ve Güvenlik Sistemleri",
    tag: "GÜVENLİK",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1617897903246-719242758050?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw1fHxzZWN1cml0eSUyMGNhbWVyYSUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3OTM3OTQ4MzZ8MA&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Kablolu/kablosuz kamera kurulumu, kayıt cihazı bağlantısı ve telefondan uzaktan izleme ayarı.",
    meta: "Beylikdüzü kamera montajı: güvenlik kamerası kurulumu, kayıt cihazı ve telefondan izleme ayarı. Arayın: 0530 956 27 70",
    pageDesc:
      "Evinizi veya iş yerinizi uzaktan görmek istiyorsanız doğru yerdesiniz. Beylikdüzü'nde kablolu ve kablosuz güvenlik kamerası kurulumu, kayıt cihazı (NVR/DVR) bağlantısı ve telefondan uzaktan izleme ayarlarını anahtar teslim yapıyoruz.",
    extra:
      "Kamera yerleşimini kör nokta kalmayacak şekilde birlikte planlıyoruz; kabloları gizleyerek estetiği koruyoruz. Kurulum sonrası telefonunuza uygulamayı kurar, hareket bildirimlerini ayarlar, sistemi size kullandırtarak teslim ederiz. Mevcut sisteminizdeki arızalara da bakıyoruz.",
    scope: [
      "IP ve analog kamera kurulumu",
      "Kayıt cihazı (NVR/DVR) bağlantısı",
      "Telefondan uzaktan izleme ayarı",
      "Apartman ve site ortak alan kamerası",
      "İş yeri ve depo kamera sistemleri",
      "Mevcut sistem arıza tespiti ve bakımı",
    ],
  },
  {
    slug: "diafon",
    title: "Diafon & Görüntülü Kapı Telefonu",
    shortTitle: "Diafon ve Görüntülü Kapı Telefonu",
    tag: "MONTAJ",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGhvbWUlMjBpbnRlcmNvbSUyMGRvb3JiZWxsfGVufDB8fHx8MTc5Mzc5NDgzNnww&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Bina ve daire diafon montajı, görüntülü kapı telefonu değişimi ve arıza onarımı.",
    meta: "Beylikdüzü'nde diafon ve görüntülü kapı telefonu montajı, bina santrali ve arıza onarımı. Arayın: 0530 956 27 70",
    pageDesc:
      "Kapıya çıkmadan kimin geldiğini görün. Beylikdüzü'nde bina ve daire diafon montajı, görüntülü kapı telefonu değişimi, zil paneli ve kapı otomatiği bağlantılarını yapıyoruz. Apartman ortak sistemlerinde santral arızası ve hat yenileme işlerini de üstleniyoruz.",
    extra:
      "Eski sesli sistemleri görüntülüye dönüştürürken mevcut kablolamayı mümkünse koruyarak maliyeti düşürüyoruz. Apartman işlerinde tüm dairelerle uyumlu marka/model seçimi için yöneticiye seçenek sunar, montajı daire daire planlı tamamlarız.",
    scope: [
      "Görüntülü diafon montajı ve değişimi",
      "Sesli diafondan görüntülüye dönüşüm",
      "Bina diafon santrali arıza onarımı",
      "Zil paneli ve kapı otomatiği bağlantısı",
      "Dış kapı kameralı kapı telefonu",
      "Daire içi monitör yer değişimi",
    ],
  },
  {
    slug: "internet-data",
    title: "İnternet & Data Hattı",
    shortTitle: "İnternet ve Data Hattı",
    tag: "ALTYAPI",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwY2FibGVzJTIwZXRoZXJuZXR8ZW58MHx8fHwxNzkzNzk0ODM2fDA&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Cat6 data kablosu çekimi, modem/router kurulumu, oda içi internet prizi ve kablo sonlandırma.",
    meta: "Beylikdüzü'nde internet hattı çekimi, Cat6 data kablosu, modem kurulumu ve internet prizi. Arayın: 0530 956 27 70",
    pageDesc:
      "Kablosuz sinyalin yetmediği odalara kablolu internet götürüyoruz. Beylikdüzü'nde Cat6 data kablosu çekimi, modem ve router kurulumu, oda içi internet prizi montajı ve kablo sonlandırma işlerini yapıyoruz. Evden çalışanlar için kesintisiz bağlantı altyapısı kuruyoruz.",
    extra:
      "Çektiğimiz her hattı test cihazıyla ölçer, uçlarını etiketleriz. Modeminizi en verimli noktaya taşır, gerekiyorsa ek erişim noktası (access point) kurarak evin her köşesinde güçlü sinyal sağlarız. İş yerlerinde switch kurulumu ve kablo düzenleme de yapıyoruz.",
    scope: [
      "Cat6 data kablosu çekimi ve sonlandırma",
      "Oda içi internet (RJ45) prizi montajı",
      "Modem ve router kurulumu, yer değişimi",
      "Access point ile kapsama alanı genişletme",
      "Hat testi ve etiketleme",
      "Ofis switch ve kablo düzenleme",
    ],
  },
  {
    slug: "uydu-tv",
    title: "Uydu & TV Tesisatı",
    shortTitle: "Uydu ve TV Tesisatı",
    tag: "MONTAJ",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1593784991095-a205069470b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzYXRlbGxpdGUlMjBkaXNoJTIwcm9vZnRvcHxlbnwwfHx8fDE3OTM3OTQ4MzZ8MA&ixlib=rb-4.1.0&q=85",
    cardDesc:
      "Uydu anten ayarı, çanak montajı, kablo hattı çekimi ve merkezi uydu dağıtım bağlantıları.",
    meta: "Beylikdüzü'nde uydu anten ayarı, çanak montajı, merkezi uydu sistemi ve TV prizi işleri. Arayın: 0530 956 27 70",
    pageDesc:
      "Sinyal yok, kanallar gidip geliyor ya da yeni televizyon mu aldınız? Beylikdüzü'nde uydu anten ayarı, çanak montajı, kablo hattı çekimi ve merkezi uydu dağıtım bağlantılarını yapıyoruz. TV ünitesi arkası priz ve kablo gizleme işlerini de hallediyoruz.",
    extra:
      "Merkezi sistemli binalarda daire bazlı sinyal sorunlarını dağıtım noktasından daireye kadar ölçerek çözüyoruz. Çanak montajında rüzgâra dayanıklı sabitleme yapar, sinyali ölçüm cihazıyla en yüksek kaliteye ayarlarız.",
    scope: [
      "Çanak anten montajı ve sinyal ayarı",
      "Merkezi uydu sistemi daire bağlantısı",
      "LNB ve çoklayıcı (multiswitch) değişimi",
      "Uydu kablosu çekimi ve yenileme",
      "TV prizi ve ünite arkası kablo gizleme",
      "Sinyal zayıflığı ve kanal sorunu tespiti",
    ],
  },
];
